// extracted by mini-css-extract-plugin
export default {"img":"Background_img__seMzl","wrapper":"Background_wrapper__vQuAM","hidden":"Background_hidden__KSmne"};